export const VENDOR_REQUEST_LIST = "VENDOR_REQUEST_LIST";
export const VENDOR_ONBOARDED_LIST = "VENDOR_ONBOARDED_LIST";
export const VENDOR_PAYMENT_ADD = "VENDOR_PAYMENT_ADD";
export const PO_DETAIL = "PO_DETAIL";
export const PAYMENT_LIST = "PAYMENT_LIST";
export const VENDOR_PAYMENT_DETAIL = "VENDOR_PAYMENT_DETAIL";
export const PAYMENT_REQUEST_LIST = "PAYMENT_REQUEST_LIST";
export const VENDOR_PAYMENT_REQUEST_DETAIL = "VENDOR_PAYMENT_REQUEST_DETAIL";
export const FILTER_LIST = "FILTER_LIST";
export const VENDOR_DEPARTMENT = "VENDOR_DEPARTMENT";
export const INVOICE_REQUEST_DETAILS = "INVOICE_REQUEST_DETAILS";
export const INVOICE_REQUEST_LIST = "INVOICE_REQUEST_LIST";
export const REQUEST_INVOICE_REQUEST_DETAILS = "REQUEST_INVOICE_REQUEST_DETAILS";
export const GET_VENDOR_DEPARTMENTS = "GET_VENDOR_DEPARTMENTS";
export const ADD_VENDOR_ADVANCES = "ADD_VENDOR_ADVANCES";
export const APPROVE_VENDOR = "APPROVE_VENDOR";
